$(function () {
  var owlCarousel = $('[data-bind="carousel"]'),
    owlOptions = owlCarousel.data(),
    owlSettings = {
      singleItem: true
    };

  $.extend(owlSettings, owlOptions);

  owlCarousel.owlCarousel(owlSettings);
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/owl-carousel.js